// 合计配置
export default new Map([
  [1, { // 货品明细
    view: new Map([['selection', '合计']]),
    str: ['bookingNum', 'acceptanceNum', 'upperShelfNum'], // 展示为xx整xx零
  }],
]);
